"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_i18next_1 = require("react-i18next");

var styled_1 = __importDefault(require("@emotion/styled"));

var polished_1 = require("polished");

var themes_1 = require("./themes");

var AutoSuggestContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  margin: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  z-index: 9;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 768px) {\n    & {\n      position: relative;\n      margin: 8px 0;\n    }\n  }\n"], ["\n  position: ", ";\n  margin: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  z-index: 9;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 768px) {\n    & {\n      position: relative;\n      margin: 8px 0;\n    }\n  }\n"])), function (props) {
  return props.expanded ? 'fixed' : 'relative';
}, function (props) {
  return props.expanded ? '0' : '8px 0';
});
var AutoSuggestBar = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var AutoSuggestList = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  overflow: auto;\n"], ["\n  flex: 1;\n  overflow: auto;\n"])));
var AutoSuggestButton = styled_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 4px;\n  white-space: nowrap;\n  background-color: transparent;\n  border: none;\n  margin: 0;\n  padding: 12px 16px;\n  height: 50px;\n  line-height: 20px;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 4px;\n  white-space: nowrap;\n  background-color: transparent;\n  border: none;\n  margin: 0;\n  padding: 12px 16px;\n  height: 50px;\n  line-height: 20px;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: 0;\n  }\n"])));
var AutoSuggestItem = styled_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  background: transparent;\n  border: none;\n  padding: 10px 15px;\n  text-align: left;\n  width: 100%;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: block;\n  background: transparent;\n  border: none;\n  padding: 10px 15px;\n  text-align: left;\n  width: 100%;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  var _a, _b, _c, _d;

  return polished_1.darken(0.2, (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.surface) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.colors.surface.color));
});
var AutoSuggestInput = styled_1.default.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 16px;\n  border: none;\n  margin-bottom: 0;\n  outline: none;\n  flex: 1;\n  padding: 12px 16px;\n  margin: 0;\n  height: 50px;\n  line-height: 20px;\n  box-sizing: border-box;\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  font-size: 16px;\n  border: none;\n  margin-bottom: 0;\n  outline: none;\n  flex: 1;\n  padding: 12px 16px;\n  margin: 0;\n  height: 50px;\n  line-height: 20px;\n  box-sizing: border-box;\n  &:focus {\n    outline: 0;\n  }\n"])));

exports.AutoSuggest = function (_a) {
  var onFilter = _a.onFilter,
      onSelect = _a.onSelect,
      items = _a.items,
      placeholder = _a.placeholder,
      render = _a.render;

  var _b = react_1.useState(false),
      expanded = _b[0],
      setExpanded = _b[1];

  var _c = react_1.useState(''),
      query = _c[0],
      setQuery = _c[1];

  var t = react_i18next_1.useTranslation().t;

  var changeQuery = function changeQuery(e) {
    e.preventDefault();
    setQuery(e.target.value);
  };

  var filteredItems = items && items.filter(function (item) {
    return onFilter(item, query);
  });
  return react_1.default.createElement(AutoSuggestContainer, {
    expanded: expanded
  }, react_1.default.createElement(AutoSuggestBar, null, react_1.default.createElement(AutoSuggestInput, {
    autoComplete: "off",
    autoCorrect: "off",
    placeholder: 'Expanded: ' + expanded + ', ' + typeof expanded,
    onClick: function onClick() {
      return setExpanded(true);
    },
    onFocus: function onFocus() {
      return setExpanded(true);
    },
    value: query,
    onChange: changeQuery
  }), react_1.default.createElement(AutoSuggestButton, {
    onClick: function onClick() {
      return setExpanded(false);
    }
  }, t('action.cancel'))), react_1.default.createElement(AutoSuggestList, null, expanded && filteredItems && filteredItems.map(function (item, index) {
    return react_1.default.createElement(AutoSuggestItem, {
      key: index,
      onClick: function onClick(e) {
        e.preventDefault();
        onSelect(item);
      }
    }, render(item));
  })));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;